import { tryParseJwtClaims } from '../core/jwt.js';
import { useAppStore } from './app-store.js';
import { usePermissionsStore } from './permissions-store.js';

export function bootstrapFromJwt(jwt: string | null): void {
  if (!jwt) {
    useAppStore.getState().clearAuth();
    usePermissionsStore.getState().clear();
    return;
  }

  const claims = tryParseJwtClaims(jwt);
  if (!claims) return;

  const app = useAppStore.getState();
  app.setTokens(jwt);

  const locale = typeof claims.locale === 'string' ? (claims.locale as string) : null;
  const timezone =
    typeof claims.timezone === 'string'
      ? (claims.timezone as string)
      : typeof claims.tz === 'string'
        ? (claims.tz as string)
        : null;
  if (locale) app.setLocale(locale);
  if (timezone) app.setTimezone(timezone);
  useAppStore.setState({ resolvedFromJwt: true });

  const userId =
    typeof claims.sub === 'string' ? (claims.sub as string) : typeof claims.user_id === 'string' ? (claims.user_id as string) : null;
  if (userId) {
    const user: {
      id: string;
      email?: string;
      organisationId?: string;
      roles?: string[];
    } = { id: userId };
    if (typeof claims.email === 'string') user.email = claims.email as string;
    const orgId =
      typeof claims.organisation_id === 'string'
        ? (claims.organisation_id as string)
        : typeof claims.tenant_id === 'string'
          ? (claims.tenant_id as string)
          : null;
    if (orgId) user.organisationId = orgId;
    const rolesClaim = claims.role ?? claims.roles;
    if (Array.isArray(rolesClaim)) user.roles = rolesClaim as string[];
    else if (typeof rolesClaim === 'string') user.roles = [rolesClaim];
    app.setUser(user);
  }

  usePermissionsStore.getState().setFromJwt(jwt);
}
